import { render } from "./LoyaltyBirthdayField.vue?vue&type=template&id=42e16898&scoped=true"
import script from "./LoyaltyBirthdayField.vue?vue&type=script&lang=js"
export * from "./LoyaltyBirthdayField.vue?vue&type=script&lang=js"

import "./LoyaltyBirthdayField.vue?vue&type=style&index=0&id=42e16898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e16898"]])

export default __exports__